export function GetMenuData() {
    return [{
        path: '/',
        name: '首页',
        key: '1',
    },
    {
        path: '/sys',
        key: '3',
        name: '系统设置',
        routes: [
            {
                path: 'user',
                name: '用户管理',
            },
            {
                path: 'roles',
                name: '角色管理',
            },
            {
                path: 'emailtemplate',
                name: '邮件模板',
            },
            {
                path: '/icons2',
                name: '菜单管理',
            },
        ],
    }, {
        name: '项目变更',
        key: '4',
        path: '/So/sochange',
        routes: [],
    }, {
        path: '/Change/myrequestlist',
        name: '变更记录',
        key: '5',
        routes: [
            // {
            //     name: "我的申请",
            //     path: "myrequestlist",
            // }
        ]
    },
    {
        path: '/CCS/applicationlist',
        name: '船级社',
        key: '6',
        routes: [
            // {
            //     path: 'applicationlist',
            //     name: '申请信息',
            // },
        ],
    },
    ]
}